import type { ComponentProps } from 'react';
import { OwcBackdrop } from '@one/react';

export type PocBackdropProps = ComponentProps<typeof OwcBackdrop>;

export const PocBackdrop: React.FC<PocBackdropProps> = (props) => <OwcBackdrop {...props} />;
